import cx from 'classnames'
import { ReactNode, MouseEvent } from 'react'
import { isNil } from 'lodash'

import { Link } from 'features/i18n/router'

import './style.scss'

type Props = {
  className?: string
  to?: string
  onClick?: (e: MouseEvent) => void
  external?: boolean
  children: ReactNode | ReactNode[]
}

export const NavItem = ({
  className,
  to,
  onClick,
  external,
  children,
}: Props) => (
  <li className={className}>
    {isNil(to) ? (
      <a className={`Menu__panel__ul__a`} onClick={onClick}>
        {children}
      </a>
    ) : isNil(external) ? (
      <Link className={`Menu__panel__ul__a`} to={to} onClick={onClick}>
        {children}
      </Link>
    ) : (
      <a
        className={`Menu__panel__ul__a`}
        href={to}
        target="_blank"
        rel="nofollow noopener noreferrer"
      >
        {children}
      </a>
    )}
  </li>
)
